import { Adunit } from '@/components/Adunit';
import { LabradorComponent } from '@/types/component';

export const LabradorAdunit: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <Adunit data={data} {...props} />;
};
